import { useState, useEffect } from "react";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import api from "../../api/api";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useProfileStore } from "../../store/useUserStore";
import { TbBuildingBank } from "react-icons/tb";
import { formatTimeSlotList } from "../../helpers/helper";

function isIOS() {
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !("MSStream" in window)
  );
}

const PaymentHistory = () => {
  const navigate = useNavigate();
  const [histories, setHistories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const pageSize = 10;
  const { t } = useTranslation();

  const { setSelectedStudent, setLoading } = useProfileStore();

  useEffect(() => {
    getHistory(currentPage);
    readOrderNotification();
  }, [currentPage]);

  function getHistory(page: number) {
    setLoading(true);
    api
      .get(`${process.env.REACT_APP_API_BASE_URL}/order`, {
        params: {
          page: page,
          page_size: pageSize,
        },
      })
      .then((res) => {
        const data = res.data.result.data;

        const totalPage = res.data.result.total_page || 1;
        setTotalPages(totalPage);

        for (let result of data) {
          result["expaned"] = false;
        }
        console.log("res history", data);
        setHistories(data);
      })
      .catch((err) => {
        console.log("err cart", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function readOrderNotification() {
    // read order notification
    api
      .post(`${process.env.PUBLIC_URL}/order/seen`)
      .then((res) => {
        console.log("res notif", res);
      })
      .catch((err) => {
        // toast.error(t("server_error"))
        console.log("err", err);
      });
  }

  function getHistoryById(historyId: number) {
    // dispatch(setLoading(true))
    // api.get(`${process.env.REACT_APP_API_BASE_URL}/order/${historyId}`).then(res => {
    //     dispatch(setLoading(false))
    //     console.log("res historyId", res.data.data)
    //     // setHistories((prevHistories:any) => prevHistories.map((history:any) => history.id === historyId ? { ...history, expanded: !history.expanded, order_items: res.data.data.order_items } : { ...history, expanded: false } ) )
    setHistories((prevHistories: any) =>
      prevHistories.map((history: any) =>
        history.id === historyId
          ? { ...history, expanded: !history.expanded }
          : { ...history, expanded: false },
      ),
    );
    // }).catch(err => {
    //     dispatch(setLoading(false))
    //     console.log("err cart", err)
    // })
  }

  function repeatPayment(orderId: any) {
    var windowReference = window.open();
    console.log("repeatPayment", orderId);
    setLoading(true);
    api
      .post(`${process.env.PUBLIC_URL}/order/pay`, {
        order_id: orderId,
      })
      .then((res) => {
        setLoading(false);
        console.log("res", res);
        const paymentUrl = res.data.payment_url;
        if (paymentUrl) {
          windowReference!.location = paymentUrl;
        } else {
          toast.error(t("url_not_found"));
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(t("server_error"));
        console.log("err", err);
      });
  }

  const navigateBack = () => {
    if (window.history?.length && window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/profile", { replace: true });
    }
  };

  function navigateItem(
    item_id: number,
    course_branch_id: number,
    student_id: number,
    student_name: string,
  ) {
    setSelectedStudent({ id: student_id, name: student_name });
    return navigate(`/item/${item_id}?course_branch_id=${course_branch_id}`);
  }

  function navigateCourseBranch(
    course_branch_id: number,
    student_id: number,
    student_name: string,
  ) {
    setSelectedStudent({ id: student_id, name: student_name });
    return navigate(`/course/${course_branch_id}`);
  }

  function viewReceipt(orderId: number) {
    setLoading(true);
    api
      .get(`${process.env.REACT_APP_API_BASE_URL}/order/invoice/${orderId}`, {
        responseType: "blob",
      })
      .then((response) => {
        setLoading(false);
        // Create blob from response
        const file = new Blob([response.data], { type: "application/pdf" });
        // Create URL for the blob
        const fileURL = URL.createObjectURL(file);

        if (isIOS()) {
          // iOS Safari: open in the same tab
          window.location.href = fileURL;
        } else {
          // For non-iOS: open in new tab as intended
          window.open(fileURL);
        }

        // Always clean up
        URL.revokeObjectURL(fileURL);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(t("server_error"));
        console.error("err", err);
      });
  }

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  return (
    <div className="pb-28">
      <div className="mb-2 grid grid-cols-4 px-2">
        <div>
          <IoIosArrowBack
            size={28}
            color="#000"
            onClick={() => navigateBack()}
          />
        </div>
        <div className="text-center col-span-2 text-lg font-medium">
          {t("payment_history.payment_history")}
        </div>
        <div></div>
      </div>

      <div className="px-2">
        {histories.map((history: any, index: number) => {
          return (
            <div
              className="shadow-[0_2px_6px_lightgray] rounded-md"
              key={index}
            >
              <div className="grid grid-cols-12 gap-4 items-center justify-between p-4 ">
                <div className="col-span-3 lg:col-span-3 text-center text-white">
                  <div
                    className={`p-1 rounded-xl text-sm ${
                      history.status === "paid"
                        ? "bg-theme text-white"
                        : "bg-red-500 text-white"
                    }`}
                  >
                    {history.status === "paid"
                      ? t("payment_history.paid")
                      : t("payment_history.unpaid")}
                  </div>
                </div>
                <div className="col-span-4 lg:col-span-3 text-lg font-medium">
                  {history.purchased_date}
                </div>
                <div className="col-span-4 lg:col-span-5 text-lg font-medium justify-self-end truncate">
                  RM {(history.total_price || 0).toFixed(2)}
                </div>
                <button
                  className="col-span-1 text-gray-500 hover:text-gray-700 transition justify-self-end"
                  onClick={() => {
                    getHistoryById(history.id);
                  }}
                >
                  {history.expanded === true ? (
                    <FaChevronDown />
                  ) : (
                    <FaChevronRight />
                  )}
                </button>
              </div>

              {history.expanded &&
                history.content &&
                history.content.length > 0 &&
                history.content.map((student: any, index2: number) => {
                  const shownBranches = new Set();

                  return (
                    <div className="px-4 border-b border-gray-300" key={index2}>
                      <div className="my-3 text-lg font-bold">
                        {student.student_name}
                      </div>
                      {student.items &&
                        student.items.length > 0 &&
                        student.items.map((item: any, index3: number) => {
                          if (item.type == "course") {
                            return (
                              <div key={index3}>
                                {item.branch_name &&
                                  !shownBranches.has(item.branch_name) &&
                                  (() => {
                                    shownBranches.add(item.branch_name);
                                    return (
                                      <div className="flex items-center bg-blue-100 rounded-lg px-3 py-1 my-3 mt-4 w-full">
                                        <TbBuildingBank className="mr-2" />
                                        <span className="font-medium text-sm text-gray-700 truncate">
                                          {item.branch_name}
                                        </span>
                                      </div>
                                    );
                                  })()}
                                <div className="grid grid-cols-12 items-center mb-3 gap-2">
                                  <div
                                    onClick={() => {
                                      navigateCourseBranch(
                                        item.course_branch_id,
                                        student.student_id,
                                        student.student_name,
                                      );
                                    }}
                                    className="col-span-3 md:col-span-2 bg-gray-100 cursor-pointer"
                                  >
                                    {item.course.images &&
                                    item.course.images.length > 0 ? (
                                      <img
                                        className="w-full h-full max-h-20"
                                        alt={t("payment_history.product")}
                                        src={item.course.images[0]}
                                      />
                                    ) : (
                                      <img
                                        className="w-full h-full object-cover"
                                        alt={t("payment_history.product")}
                                        src="/assets/img/products/product1.png"
                                      />
                                    )}
                                  </div>

                                  <div className="col-span-6 md:col-span-8 flex flex-col justify-center space-y-1">
                                    <h3
                                      onClick={() => {
                                        navigateCourseBranch(
                                          item.course_branch_id,
                                          student.student_id,
                                          student.student_name,
                                        );
                                      }}
                                      className="text-base font-medium truncate cursor-pointer"
                                    >
                                      {item.course.name || "-"}
                                    </h3>
                                    <span className="text-sm text-gray-600 truncate">
                                      {formatTimeSlotList(item.schedules)}
                                    </span>
                                    <p className="text-sm text-gray-600 break-words whitespace-normal">
                                      {item.selected_date === ""
                                        ? item.package && item.package.count
                                          ? item.package.count +
                                            ` ${t(
                                              "payment_history.attendance",
                                            )}`
                                          : "-"
                                        : item.selected_date}
                                    </p>
                                  </div>

                                  <div className="col-span-3 md:col-span-2 text-right">
                                    <p className="text-lg font-medium text-gray-700">
                                      RM {item.price || "0"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            );
                          } else if (item.type == "item") {
                            return (
                              <div key={index3}>
                                {item.branch_name &&
                                  !shownBranches.has(item.branch_name) &&
                                  (() => {
                                    shownBranches.add(item.branch_name);
                                    return (
                                      <div className="flex items-center bg-blue-100 rounded-lg px-3 py-1 my-3 mt-4 w-full">
                                        <TbBuildingBank className="mr-2" />
                                        <span className="font-medium text-sm text-gray-700 truncate">
                                          {item.branch_name}
                                        </span>
                                      </div>
                                    );
                                  })()}
                                <div className="grid grid-cols-12 items-center mb-3 gap-2">
                                  <div
                                    onClick={() => {
                                      navigateItem(
                                        item.item.id,
                                        item.course_branch_id,
                                        student.student_id,
                                        student.student_name,
                                      );
                                    }}
                                    className="col-span-3 md:col-span-2 bg-gray-100 cursor-pointer"
                                  >
                                    {item.item.images &&
                                    item.item.images.length > 0 ? (
                                      <img
                                        className="w-full h-full max-h-20"
                                        alt={t("payment_history.product")}
                                        src={item.item.images[0]}
                                      />
                                    ) : (
                                      <img
                                        className="w-full h-full object-cover"
                                        alt={t("payment_history.product")}
                                        src="/assets/img/products/product1.png"
                                      />
                                    )}
                                  </div>

                                  <div className="col-span-6 md:col-span-8 flex flex-col justify-center space-y-1">
                                    <h3
                                      onClick={() => {
                                        navigateItem(
                                          item.item.id,
                                          item.course_branch_id,
                                          student.student_id,
                                          student.student_name,
                                        );
                                      }}
                                      className="text-base font-medium truncate cursor-pointer"
                                    >
                                      {item.item.name || "-"}
                                    </h3>
                                    <span className="text-sm text-gray-600">
                                      Quantity: {item.quantity}
                                    </span>
                                    <div></div>
                                  </div>
                                  <div className="col-span-3 md:col-span-2 text-right">
                                    <p className="text-lg font-medium text-gray-700">
                                      RM {item.total_price || "0"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            );
                          } else if (item.type == "wave") {
                            let waiveBalancePrice = 0;

                            if (item.payment_method === "month") {
                              waiveBalancePrice = item.price;
                            } else {
                              waiveBalancePrice = item.price || 0;
                            }

                            return (
                              <div key={index3}>
                                {item.branch_name &&
                                  !shownBranches.has(item.branch_name) &&
                                  (() => {
                                    shownBranches.add(item.branch_name);
                                    return (
                                      <div className="flex items-center bg-blue-100 rounded-lg px-3 py-1 my-3 mt-4 w-full">
                                        <TbBuildingBank className="mr-2" />
                                        <span className="font-medium text-sm text-gray-700 truncate">
                                          {item.branch_name}
                                        </span>
                                      </div>
                                    );
                                  })()}
                                <div className="grid grid-cols-12 items-center mb-3 gap-2">
                                  <div
                                    onClick={() => {
                                      navigateCourseBranch(
                                        item.course_branch_id,
                                        student.student_id,
                                        student.student_name,
                                      );
                                    }}
                                    className="col-span-3 md:col-span-2 bg-gray-100 cursor-pointer"
                                  >
                                    {item.course.images &&
                                    item.course.images.length > 0 ? (
                                      <img
                                        className="w-full h-full max-h-20"
                                        alt={t("payment_history.product")}
                                        src={item.course.images[0]}
                                      />
                                    ) : (
                                      <img
                                        className="w-full h-full object-cover"
                                        alt={t("payment_history.product")}
                                        src="/assets/img/products/product1.png"
                                      />
                                    )}
                                  </div>

                                  <div className="col-span-6 md:col-span-8 flex flex-col justify-center space-y-1">
                                    <h3
                                      onClick={() => {
                                        navigateCourseBranch(
                                          item.course_branch_id,
                                          student.student_id,
                                          student.student_name,
                                        );
                                      }}
                                      className="text-base font-medium truncate cursor-pointer"
                                    >
                                      Waive Payment
                                    </h3>
                                    <span className="text-sm text-gray-600 truncate">
                                      {item.course.name || "-"}
                                    </span>
                                    <p className="text-sm text-gray-600 break-words whitespace-normal">
                                      {item.selected_date || "-"}
                                    </p>
                                  </div>

                                  <div className="col-span-3 md:col-span-2 text-right">
                                    <p className="text-lg font-medium text-red-600">
                                      RM {(waiveBalancePrice || 0).toFixed(2)}
                                    </p>
                                  </div>
                                </div>

                                {item.remark && (
                                  <div className="mb-3 p-2 border border-gray-300 rounded">
                                    <span className="text-theme text-sm">
                                      {item.remark}
                                    </span>
                                  </div>
                                )}
                              </div>
                            );
                          }
                        })}
                    </div>
                  );
                })}
              {history.expanded && (
                <div className="px-4 pt-4 pb-3">
                  <div className="grid grid-cols-2 text-base mb-1">
                    <div>{t("payment_history.payment_method")}</div>
                    <div className="text-end">
                      {history.payment_method || "-"}
                    </div>
                  </div>
                  <div className="grid grid-cols-2 text-base mb-1">
                    <div>{t("payment_history.payment_status")}</div>
                    <div className="text-end">
                      {history.status.charAt(0).toUpperCase() +
                        history.status.slice(1)}
                    </div>
                  </div>
                  <div className="grid grid-cols-2 text-base mb-1">
                    <div>{t("payment_history.order_id")}</div>
                    <div className="text-end">
                      {history.order_id == "" || !history.order_id
                        ? "-"
                        : history.order_id}
                    </div>
                  </div>
                  <div className="grid grid-cols-2 text-base mb-1">
                    <div>{t("payment_history.payment_date")}</div>
                    <div className="text-end">{history.purchased_date}</div>
                  </div>

                  {/* Discount Section */}
                  {history.discount &&
                    history.discount.length > 0 &&
                    history.discount.some((discountItem: any) => {
                      const siblingDiscount = parseFloat(
                        discountItem.sibling_discount_total || 0,
                      );
                      const bundleDiscount = parseFloat(
                        discountItem.bundle_discount_total || 0,
                      );
                      const batchDiscount = parseFloat(
                        discountItem.batch_discount_total || 0,
                      );
                      return (
                        siblingDiscount > 0 ||
                        bundleDiscount > 0 ||
                        batchDiscount > 0
                      );
                    }) && (
                      <div className="mt-4 pt-2 border-t border-gray-200">
                        <div className="text-base font-semibold mb-2">
                          {t("payment_history.discount_summary")}
                        </div>

                        {/* Filter and display academies with discounts */}
                        {history.discount
                          .filter((discountItem: any) => {
                            const siblingDiscount = parseFloat(
                              discountItem.sibling_discount_total || 0,
                            );
                            const bundleDiscount = parseFloat(
                              discountItem.bundle_discount_total || 0,
                            );
                            const batchDiscount = parseFloat(
                              discountItem.batch_discount_total || 0,
                            );
                            return (
                              siblingDiscount > 0 ||
                              bundleDiscount > 0 ||
                              batchDiscount > 0
                            );
                          })
                          .map((discountItem: any, discountIndex: number) => (
                            <div
                              key={discountIndex}
                              className="mb-3 p-2 bg-gray-50 rounded-lg"
                            >
                              <div className="text-sm font-medium mb-1">
                                {discountItem.academy_name}
                              </div>
                              <div className="space-y-1">
                                {parseFloat(
                                  discountItem.sibling_discount_total,
                                ) > 0 && (
                                  <div className="grid grid-cols-2 text-sm">
                                    <div className="text-red-500">
                                      {t("payment_history.sibling_discount")}:
                                    </div>
                                    <div className="text-end text-red-500 font-semibold">
                                      -RM {discountItem.sibling_discount_total}
                                    </div>
                                  </div>
                                )}
                                {parseFloat(
                                  discountItem.bundle_discount_total,
                                ) > 0 && (
                                  <div className="grid grid-cols-2 text-sm">
                                    <div className="text-orange-500">
                                      {t("payment_history.bundle_discount")}:
                                    </div>
                                    <div className="text-end text-orange-500 font-semibold">
                                      -RM {discountItem.bundle_discount_total}
                                    </div>
                                  </div>
                                )}
                                {parseFloat(discountItem.batch_discount_total) >
                                  0 && (
                                  <div className="flex justify-between items-center text-sm mb-1">
                                    <span className="text-blue-500">
                                      {t("promotion.batch_discount")}
                                    </span>
                                    <span className="text-blue-500">
                                      - RM{" "}
                                      {parseFloat(
                                        discountItem.batch_discount_total,
                                      ).toFixed(2)}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          ))}

                        {/* Total Saved Section */}
                        <div className="mt-3 pt-2 border-t border-gray-300">
                          <div className="grid grid-cols-2 text-sm font-medium">
                            <div className="text-gray-700">Total Saved:</div>
                            <div className="text-end text-gray-700">
                              -RM{" "}
                              {history.discount
                                .reduce((total: number, discountItem: any) => {
                                  const siblingDiscount = parseFloat(
                                    discountItem.sibling_discount_total || 0,
                                  );
                                  const bundleDiscount = parseFloat(
                                    discountItem.bundle_discount_total || 0,
                                  );
                                  const batchDiscount = parseFloat(
                                    discountItem.batch_discount_total || 0,
                                  );
                                  return (
                                    total +
                                    siblingDiscount +
                                    bundleDiscount +
                                    batchDiscount
                                  );
                                }, 0)
                                .toFixed(2)}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                  <div className="grid grid-cols-2 text-lg mb-1 font-bold">
                    <div>{t("payment_history.total_amount")}</div>
                    <div className="text-end">RM {history.total_price}</div>
                  </div>

                  {history.status === "paid" && (
                    <div className="grid grid-cols-2 text-base mb-1 text-gray-500 border-t border-gray-200 pt-2 mt-4">
                      <div>{t("payment_history.receipt")}</div>
                      <div
                        className="justify-self-end whitespace-nowrap flex items-center gap-1"
                        onClick={() => viewReceipt(history.id)}
                      >
                        <span>{t("payment_history.view")}</span>
                        <FaChevronRight />
                      </div>
                    </div>
                  )}

                  {history.status !== "paid" && (
                    <div className="mt-3 font-semibold flex justify-end">
                      <div
                        className="p-2 px-4 rounded-xl w-3/5 text-center"
                        style={{ backgroundColor: "#f5ce00" }}
                        onClick={() => {
                          repeatPayment(history.id);
                        }}
                      >
                        {" "}
                        $ {t("payment_history.pay_now")}{" "}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Replace the pagination controls */}
      <div className="grid grid-cols-12 items-center px-4 mt-4 gap-1 md:gap-2">
        <div className="col-span-8 md:col-span-8"></div>
        <button
          onClick={handlePrevPage}
          disabled={currentPage === 1}
          className={`col-span-2 md:col-span-2 p-1.5 md:p-2 rounded-lg ${
            currentPage === 1
              ? "bg-gray-300 cursor-not-allowed text-gray-500"
              : "bg-theme hover:bg-theme text-white"
          }`}
        >
          <IoIosArrowBack size={16} className="mx-auto" />
        </button>
        <button
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
          className={`col-span-2 md:col-span-2 p-1.5 md:p-2 rounded-lg ${
            currentPage === totalPages
              ? "bg-gray-300 cursor-not-allowed text-gray-500"
              : "bg-theme text-white"
          }`}
        >
          <IoIosArrowForward size={16} className="mx-auto" />
        </button>
      </div>
    </div>
  );
};

export default PaymentHistory;
